<template>
  <svg width="17" height="29" viewBox="0 0 17 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.9999 1.16669H11.9999C10.2318 1.16669 8.53612 1.86907 7.28587 3.11931C6.03563 4.36955 5.33325 6.06524 5.33325 7.83335V11.8334H1.33325V17.1667H5.33325V27.8334H10.6666V17.1667H14.6666L15.9999 11.8334H10.6666V7.83335C10.6666 7.47973 10.8071 7.14059 11.0571 6.89055C11.3072 6.6405 11.6463 6.50002 11.9999 6.50002H15.9999V1.16669Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
    